import { render, staticRenderFns } from "./CardBack.vue?vue&type=template&id=2580344a&scoped=true"
var script = {}
import style0 from "./CardBack.vue?vue&type=style&index=0&id=2580344a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580344a",
  null
  
)

export default component.exports